// Required for devtools typing: supplies the Window.__REDUX_DEVTOOLS_EXTENSION__
// global that types `serialize`.
import type {} from '@redux-devtools/extension';
import {
  type StateCreator,
  create as zustandCreate,
  createStore as zustandCreateStore,
} from 'zustand';
import { devtools } from 'zustand/middleware';
import type { DangerousAny } from '@/types/dangerous-any';

const setReplacer = (_key: string, value: DangerousAny) => {
  // NOTE: set 在 redux devtool 上無法正常顯示，所以這邊才轉成 Array 的格式
  if (value instanceof Set) {
    return Array.from(value);
  }

  return value;
};

export const createAction = <T>(type: string, payload: T) => {
  return { type, payload };
};

export const create = <T>(
  name: Capitalize<string>,
  initializer: StateCreator<T, [['zustand/devtools', never]], [], T>,
) => {
  const store = zustandCreate(
    devtools(initializer, {
      name,
      serialize: {
        replacer: setReplacer,
      },
    }),
  );

  return store;
};

export const createVanillaStore = <T>(
  name: string,
  initializer: StateCreator<T, [['zustand/devtools', never]], [], T>,
) => {
  return zustandCreateStore(
    devtools(initializer, {
      name,
      serialize: {
        replacer: setReplacer,
      },
    }),
  );
};
